module.exports = __webpack_public_path__ + "img/7.01b40529.jpg";